import React from "react";
import { Box, Typography } from "@mui/material";
import Card from "@mui/material/Card";

import GroupSvg from "../../../assets/images/Group.svg";

import "@fontsource/manrope/500.css";

const WhoCanJoin = () => {
  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 380,
        borderRadius: 4,
        p: 2.5,
        bgcolor: "white",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.08)",
        mx: "auto",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 1.5,
          mb: 2.5,
        }}
      >
        <Box
          sx={{
            flex: 1,
            height: "1px",
            background:
              "linear-gradient(90deg, transparent 0%, #E0E0E0 50%, #E0E0E0 100%)",
            maxWidth: "100px",
          }}
        />
        <Typography
          sx={{
            fontSize: "12px",
            fontFamily: "Manrope",
            fontWeight: 500,
            lineHeight: "100%",
            letterSpacing: "0.8px",
            color: "rgba(0, 0, 0, 0.84)",
            whiteSpace: "nowrap",
            textTransform: "uppercase",
            px: 1,
          }}
        >
          WHO CAN JOIN ?
        </Typography>
        <Box
          sx={{
            flex: 1,
            height: "1px",
            background:
              "linear-gradient(90deg, #E0E0E0 0%, #E0E0E0 50%, transparent 100%)",
            maxWidth: "100px",
          }}
        />
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "95px",
          borderRadius: "15px",
          background: "linear-gradient(90deg, #D3FFFC 0%, #FFFFFF 100%)",
          border: "1px solid #E9E9E9",
          boxShadow: "0px 4px 16px rgba(51, 51, 51, 0.08)",
          display: "flex",
          alignItems: "center",
          padding: "0 20px 0 0",
          position: "relative",
          overflow: "hidden",
          mx: "auto",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            left: 0,
            bottom: 0,
            width: "120px",
            height: "100%",
            display: "flex",
            alignItems: "flex-end",
          }}
        >
          <img
            src={GroupSvg}
            alt="FruitX referral illustration"
            style={{
              width: "125%",
              height: "auto",
              maxHeight: "125%",
              objectFit: "contain",
              objectPosition: "left bottom",
            }}
          />
        </Box>

        <Box
          sx={{
            marginLeft: "95px",
            padding: "0 0 0 10px",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Manrope",
              fontWeight: 500,
              fontSize: "13px",
              lineHeight: "18px",
              color: "#000000",
              textAlign: "left",
            }}
          >
            This Program is exclusively for registered FruitX Customers/ Buyers
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default WhoCanJoin;
